export const createCsvBlob = (csvCode: string) => {
  return new Blob([csvCode], { type: 'text/csv' });
};
